import APIRequest from '../api/APIRequest';

const apiRequest = new APIRequest();
const API_BASE = '/admin'; // Changed from '/api/admin' to avoid double /api/ prefix from APIRequest base path

export const fieldConfigService = {
  // Get all fields for a designation
  getDesignationFields: async (designationId, token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/designations/${designationId}/fields`,
        'GET',
        null,
        token
      );
      return response;
    } catch (error) {
      console.error('Error fetching fields:', error);
      throw error;
    }
  },

  // Get all fields for an entity type ('staff', 'student')
  getEntityFields: async (entityType, token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/fields/${entityType}`,
        'GET',
        null,
        token
      );
      return response;
    } catch (error) {
      console.error(`Error fetching ${entityType} fields:`, error);
      throw error;
    }
  },

  // Add new field
  addField: async (designationId, fieldData, token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/designations/${designationId}/fields`,
        'POST',
        fieldData,
        token
      );
      return response;
    } catch (error) {
      console.error('Error adding field:', error);
      throw error;
    }
  },

  // Add field to entity
  addEntityField: async (entityType, fieldData, token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/fields/${entityType}`,
        'POST',
        { ...fieldData, entityType },
        token
      );
      return response;
    } catch (error) {
      console.error(`Error adding ${entityType} field:`, error);
      throw error;
    }
  },

  // Update field
  updateField: async (designationId, fieldId, fieldData, token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/designations/${designationId}/fields/${fieldId}`,
        'PUT',
        fieldData,
        token
      );
      return response;
    } catch (error) {
      console.error('Error updating field:', error);
      throw error;
    }
  },

  // Delete field
  deleteField: async (designationId, fieldId, token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/designations/${designationId}/fields/${fieldId}`,
        'DELETE',
        null,
        token
      );
      return response;
    } catch (error) {
      console.error('Error deleting field:', error);
      throw error;
    }
  },

  // Reorder fields
  reorderFields: async (designationId, fieldOrders, token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/designations/${designationId}/fields/reorder`,
        'POST',
        { fieldOrders },
        token
      );
      return response;
    } catch (error) {
      console.error('Error reordering fields:', error);
      throw error;
    }
  },
};
